import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { isEncryptedValue } from '../../Utils/Utils';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editScreen,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
  BooleanFlagFilterCell,
  GridFlag,
}) => {
  const dataColumns = [
    {
      field: 'ConfigId',
      title: 'Config Id',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
      excludeFromFilter: true,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editScreen(props.dataItem);
          }}
        >
          {props.dataItem.ConfigId}
        </td>
      ),
    },
    {
      field: 'Value',
      title: 'Value',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
    },
    {
      field: 'Encrypted',
      title: 'Encrypted',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 150,
      filterable: false,
      cell: (props) => (
        <td>
          {isEncryptedValue(props?.dataItem?.Value) ? (
            <FontAwesomeIcon icon={faCheck} className='grid-flag-icon' />
          ) : (
            <FontAwesomeIcon icon={faTimes} className='grid-flag-icon' />
          )}
        </td>
      ),
    },
    {
      field: 'Active',
      title: 'Active',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanFlagFilterCell,
    },
    {
      field: 'Desc',
      title: 'Description',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
    },
    {
      field: 'CreatedBy',
      title: 'Created By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'CreatedDate',
      title: 'Created Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'CreatedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'ModifiedBy',
      title: 'Modified By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'ModifiedDate',
      title: 'Modified Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ModifiedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
